// @flow

import React from "react";
import { localize } from "redux-i18n";
import { GSGrid, ChartJS, View } from "@components";
import type { AbsenceProfile } from "@modules/reporting/reducer/trends/absence-reason/types";

type OwnProps = $Exact<{
  absenceProfile: AbsenceProfile,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export const TrendAbsenceReasonAbsenceProfile = ({ absenceProfile, t }: Props) => (
  <View gap={3}>
    <GSGrid
      columns={[
        {
          name: t("MEASURE"),
          key: "key",
          align: "left",
          width: "",
        },
        {
          name: t("VALUE"),
          key: "value",
          width: "",
        },
      ]}
      rows={[
        {
          key: t("TRENDS_ABSENCE_REASON_MEASURE_TOTAL_DAYS_LOST"),
          value: absenceProfile ? absenceProfile.totalDaysLost : "",
        },
        {
          key: t("TRENDS_ABSENCE_REASON_MEASURE_ABSENCE_SPELLS"),
          value: absenceProfile ? absenceProfile.totalAbsences : "",
        },
        {
          key: t("TRENDS_ABSENCE_REASON_MEASURE_AVERAGE_DURATION"),
          value: absenceProfile ? absenceProfile.averageDuration : "",
        },
        {
          key: t("TRENDS_ABSENCE_REASON_MEASURE_DAYS_LOST_PER_EMPLOYEE"),
          value: absenceProfile ? absenceProfile.daysLostPerEmployee : "",
        },
      ]}
    />
    <ChartJS
      type="bar"
      title={t("TRENDS_ABSENCE_REASON_DLPE_BY_GENDER_TITLE")}
      className="mb-3"
      data={{
        labels: ((absenceProfile || {}).daysLostPerEmployeeByGender || []).map(item =>
          t(item.description),
        ),
        datasets: [
          {
            label: t("DAYS_LOST"),
            data: ((absenceProfile || {}).daysLostPerEmployeeByGender || []).map(
              item => item.value,
            ),
          },
        ],
      }}
      options={{ height: 200, wrapXAxisLabels: true }}
    />
    <ChartJS
      type="bar"
      title={t("TRENDS_ABSENCE_REASON_DLPE_BY_AGE_GROUP_TITLE")}
      data={{
        labels: ((absenceProfile || {}).daysLostPerEmployeeByAgeGroup || []).map(item =>
          t(item.description),
        ),
        datasets: [
          {
            label: t("DAYS_LOST"),
            data: ((absenceProfile || {}).daysLostPerEmployeeByAgeGroup || []).map(
              item => item.value,
            ),
          },
        ],
      }}
      options={{ height: 200, wrapXAxisLabels: true }}
    />
  </View>
);

export default localize()(TrendAbsenceReasonAbsenceProfile);
